import React, { useState, useEffect, useCallback } from 'react';
import { X, Menu, Calendar, Users, Award, Mail, Instagram, Facebook } from 'lucide-react';


const ReginaReviversWebsite = () => {
    const [currentPage, setCurrentPage] = useState('home');
    const [showJoinModal, setShowJoinModal] = useState(false);
    const [showSponsorModal, setShowSponsorModal] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [currentPlayerIndex, setCurrentPlayerIndex] = useState(0);
    const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
    const [fixtures, setFixtures] = useState([]);
    const [fixtureTab, setFixtureTab] = useState('T20');

    useEffect(() => {
        const CSV_URL = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vTXeI1kVGXyhdKry2PyUs_p-H9F0AO4BhvN28rt2AAmahyOuhZ3_zmTTSoN10AB5naW4mmpSX28v8YV/pub?gid=0&single=true&output=csv';

        const parseCSVRow = (row) => {
            const result = [];
            let current = '';
            let inQuotes = false;
            for (let i = 0; i < row.length; i++) {
                const char = row[i];
                if (char === '"') {
                    inQuotes = !inQuotes;
                } else if (char === ',' && !inQuotes) {
                    result.push(current.trim());
                    current = '';
                } else {
                    current += char;
                }
            }
            result.push(current.trim());
            return result;
        };

        fetch(CSV_URL)
            .then(res => res.text())
            .then(csv => {
                const rows = csv.trim().split('\n');
                const headers = parseCSVRow(rows[0]);
                const parsed = rows.slice(1)
                    .filter(row => row.trim() !== '')
                    .map((row, index) => {
                        const values = parseCSVRow(row);
                        const obj = Object.fromEntries(headers.map((h, i) => [h, values[i] ?? '']));
                        const isHome = obj['Home']?.toLowerCase().includes('revivers');
                        return {
                            id: index + 1,
                            date: obj['Date'],
                            day: obj['Day'],
                            time: obj['Game Time'],
                            sunsetTime: obj['Sunset Time'],
                            format: obj['Format'],
                            venue: obj['Ground'],
                            division: obj['vs'],
                            home: obj['Home'],
                            away: obj['Away'],
                            opponent: isHome ? obj['Away'] : obj['Home'],
                            isHomeGame: isHome,
                            status: obj['Status']?.toLowerCase().trim() || 'upcoming',
                            result: obj['Result'] || '',
                            ourScore: obj['OurScore'] || '',
                            theirScore: obj['TheirScore'] || '',
                            ourOvers: obj['OurOvers'] || '',
                            theirOvers: obj['TheirOvers'] || '',
                            mapsLink: obj['MapLink'] || '',
                        };
                    });
                setFixtures(parsed);
            })
            .catch(err => console.error('Failed to load fixtures:', err));
    }, []);

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        role: '',
        experience: '',
        message: ''
    });
    const [sponsorFormData, setSponsorFormData] = useState({
        businessName: '',
        email: '',
        phone: '',
        tier: '',
        address: '',
        comments: ''
    });

    const [joinPhoneError, setJoinPhoneError] = useState('');
    const [sponsorPhoneError, setSponsorPhoneError] = useState('');

    const players = [
        /* Agnesh */
        { name: 'Agnesh Gohil', role: 'Middle Order Batter', battingStyle: 'Right Hand Batter', bowlingStyle: '', number: '18', image: '/images/agnesh.jpeg', imagebig: '/images/agnesh.jpeg' },

        /* Deep */
        { name: 'Deep Patel', role: 'Bowling All-Rounder', battingStyle: 'Right Hand Batter', bowlingStyle: 'Slow Left Arm Orthodox', number: '03', image: '/images/jersey.jpeg', imagebig: '/images/deep.jpeg' },

        /* Jaimin */
        { name: 'Jaimin Patel', role: 'Bowling All-Rounder', battingStyle: 'Right Hand Batter', bowlingStyle: 'Right Arm Medium', number: '33', image: '/images/jersey.jpeg', imagebig: '/images/jaimin.jpeg' },

        /* Janin */
        { name: 'Janin Jayan', role: 'Batting All-Rounder', battingStyle: 'Right Hand Batter', bowlingStyle: 'Right Arm Legbreak', number: '10', image: '/images/jersey.jpeg', imagebig: '/images/janin.jpeg' },

        /* Jasbir */
        { name: 'Jasbir Singh Purba', role: 'Top Order Batter', battingStyle: 'Right Hand Batter', bowlingStyle: 'Right Arm Legbreak', number: '01', image: '/images/jersey.jpeg', imagebig: '/images/jazz.jpeg' },

        /* Javeen */
        { name: 'Javeen Jayan', role: 'Bowler', battingStyle: 'Right Hand Batter', bowlingStyle: 'Right Arm Fast', number: '28', image: '/images/jersey.jpeg', imagebig: '/images/javeen.jpeg' },

        /* Jay Patel */
        { name: 'Jay Patel', role: 'Middle Order Batter', battingStyle: 'Right Hand Batter', bowlingStyle: '', number: '7', image: '/images/jersey.jpeg', imagebig: '/images/jay.jpeg' },

        /* Karthik */
        { name: 'Karthik Raghavun', role: 'Bowling All-Rounder', battingStyle: 'Right Hand Batter', bowlingStyle: 'Right Arm Medium', number: '15', image: '/images/jersey.jpeg', imagebig: '/images/karthik.jpeg' },

        /* Krishna */
        { name: 'Krishna Geeshpath Koduru', role: 'All-Rounder', battingStyle: 'Right Hand Batter', bowlingStyle: 'Right Arm Medium', number: '4', image: '/images/jersey.jpeg', imagebig: '/images/krishna.jpeg' },

        /* Kulwinder */
        { name: 'Kulwinder Bajwa', role: 'Bowling All-Rounder', battingStyle: 'Right Hand Batter', bowlingStyle: 'Right Arm Fast', number: '21', image: '/images/jersey.jpeg', imagebig: '/images/bhajwa.jpeg' },

        /* Kapil */
        { name: 'Kapil Bavisiya', role: 'Bowler', battingStyle: 'Right Hand Batter', bowlingStyle: 'Right Arm Fast', number: '13', image: '/images/jersey.jpeg', imagebig: '/images/kapil.jpeg' },

        /* Muhzin */
        { name: 'Muhzin Musthafa', role: 'Batter', battingStyle: 'Right Hand Batter', bowlingStyle: '', number: '7', image: '/images/jersey.jpeg', imagebig: '/images/muhzin.jpeg' },

        /* Nihal */
        { name: 'Nihal Sekhar', role: 'Wicketkeeper Batter', battingStyle: 'Right Hand Batter', bowlingStyle: '', number: '6', image: '/images/jersey.jpeg', imagebig: '/images/nihal.jpeg' },

        /* Raghavun */
        { name: 'Raghavun Premkumar', role: 'All-Rounder', battingStyle: 'Right Hand Batter', bowlingStyle: 'Right Arm Medium', number: '21', image: '/images/jersey.jpeg', imagebig: '/images/raghavun.jpeg' },

        /* Rohit */
        { name: 'Rohit Varma Dasaraju', role: 'Bowling All-Rounder', battingStyle: 'Right Hand Batter', bowlingStyle: 'Right Arm Offspin', number: '18', image: '/images/jersey.jpeg', imagebig: '/images/varma.jpeg' },

        /* Saravana Raju */
        { name: 'Saravanan Raju', role: 'Bowling All-Rounder', battingStyle: 'Right Hand Batter', bowlingStyle: 'Right Arm Fast', number: '22', image: '/images/jersey.jpeg', imagebig: '/images/saravanan1.jpeg' },

        /* SK */
        { name: 'Saravanakumar [SK]', role: 'All-Rounder', battingStyle: 'Right Hand Batter', bowlingStyle: 'Right Arm Medium', number: '9', image: '/images/jersey.jpeg', imagebig: '/images/sk.jpeg' },

        /* SP Anand */
        { name: 'SP Anand', role: 'Bowler', battingStyle: 'Right Hand Batter', bowlingStyle: 'Right Arm Medium', number: '31', image: '/images/jersey.jpeg', imagebig: '/images/anand.jpg' },

        /* Vivek Munyal*/
        { name: 'Vivek Munyal', role: 'Bowling All-Rounder', battingStyle: 'Right Hand Batter', bowlingStyle: 'Right Arm Offspin', number: '00', image: '/images/jersey.jpeg', imagebig: '/images/vivek.jpeg' },

        /* Yash */
        { name: 'Yash Dave', role: 'Batting All-Rounder', battingStyle: 'Left Hand Batter', bowlingStyle: 'Right Arm Offspin', number: '18', image: '/images/jersey.jpeg', imagebig: '/images/yash.jpeg' },
    ];

    const gallery = [
        { id: 1, url: './images/bg1.png', caption: 'Fresh pitch. Fresh purpose. Revivers Cricket Foundation coming soon.' },
        { id: 2, url: './images/bg2.png', caption: 'The pavilion is buzzing... Revivers Cricket Foundation details are on the way.' },
        { id: 3, url: './images/bg1.png', caption: 'No rain delay, Revivers Cricket Foundation updates coming soon.' },
        { id: 4, url: './images/bg2.png', caption: 'We’re padding up, Revivers Cricket Foundation launches soon.' },
        { id: 5, url: './images/bg1.png', caption: 'Coach’s notebook loading... Revivers Cricket Foundation coming soon.' },
    ];

    const sponsors = [
        {
            name: 'Tarun Sharma - Royal LePage',
            tier: 'Boundary Booster',
            description: 'Professional Real Estate Services in Regina',
            details: 'Tarun Sharma is a trusted real estate professional specializing in residential and commercial properties across Regina and surrounding areas. With strong local market insight and a client-first approach, he focuses on understanding individual needs and delivering clear, reliable guidance at every stage of the real estate journey. Known for effective communication and long-term relationships, Tarun helps turn property goals into confident decisions and successful outcomes.',
            website: 'https://www.realtor.ca/agent/2200296/tarun-sharma',
            logo: '/images/tarun.jpg'
        },
        {
            name: 'Tony’s India Food Centre',
            tier: 'Quick Doubles',
            description: 'Indian & international grocery store on Victoria Ave in Regina',
            details: 'Tony’s India Food Centre is a local go-to for South Asian groceries and everyday essentials in Regina. Located on Victoria Avenue, the store is known for a strong selection of spices, lentils, rice, flours, snacks, and pantry staples—plus hard-to-find items that make home cooking easier. Whether you’re stocking up for match-day meals or grabbing quick ingredients for chai and curries, it’s a reliable neighborhood spot for flavor, value, and convenience.',
            website: 'https://www.facebook.com/Tonysfoodcenter417/',
            map: 'https://maps.app.goo.gl/nJsRBBsNkbTogBEf7',
            logo: '/images/Tony.jpeg'
        },
        {
            name: 'SaskEnergy',
            tier: 'Steady Singles',
            description: 'Saskatchewan`s provincial Crown corporation delivering safe, reliable, and affordable natural gas to homes, businesses, and industrial customers.',
            details: 'SaskEnergy provides safe and convenient energy solutions to meet the needs of homes and businesses throughout Saskatchewan by offering natural gas products and services.',
            website: 'https://www.saskenergy.com/',
            logo: '/images/saskenergy.jpg'
        }
    ];

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentPlayerIndex((prev) => (prev + 1) % players.length);
        }, 3000);
        return () => clearInterval(interval);
    }, [players.length]);

    useEffect(() => {
        const slideInterval = setInterval(() => {
            setCurrentSlideIndex((prev) => (prev + 1) % gallery.length);
        }, 4000);
        return () => clearInterval(slideInterval);
    }, [gallery.length]);

    const handleInputChange = useCallback((e) => {
        const { name, value } = e.target;
        if (name === 'phone') {
            const digitsOnly = value.replace(/\D/g, '').slice(0, 10);
            setFormData(prev => ({ ...prev, phone: digitsOnly }));
            setJoinPhoneError(digitsOnly.length > 0 && digitsOnly.length < 10 ? 'Phone number must be exactly 10 digits' : '');
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    }, []);

    const handleSponsorInputChange = useCallback((e) => {
        const { name, value } = e.target;
        if (name === 'phone') {
            const digitsOnly = value.replace(/\D/g, '').slice(0, 10);
            setSponsorFormData(prev => ({ ...prev, phone: digitsOnly }));
            setSponsorPhoneError(digitsOnly.length > 0 && digitsOnly.length < 10 ? 'Phone number must be exactly 10 digits' : '');
        } else {
            setSponsorFormData(prev => ({ ...prev, [name]: value }));
        }
    }, []);

    const handleSubmit = useCallback(async (e) => {
        e.preventDefault();

        // Show loading state
        const submitButton = e.target.querySelector('button[type="submit"]');
        const originalText = submitButton.textContent;
        submitButton.textContent = 'Submitting...';
        submitButton.disabled = true;
        if (formData.phone.length !== 10) {
            setJoinPhoneError('Phone number must be exactly 10 digits');
            submitButton.textContent = originalText;
            submitButton.disabled = false;
            return;
        }

        try {
            // REPLACE THIS URL WITH YOUR GOOGLE APPS SCRIPT WEB APP URL
            const scriptURL = 'https://script.google.com/macros/s/AKfycby4yGDdWnnf0eLnv2wtXiMp2s1dHiBAgDzjtL-8J5QLwuXcNQ0sX8Ccra_KF3LXrCFDVA/exec';

            await fetch(scriptURL, {
                method: 'POST',
                mode: 'no-cors', // Required for Google Apps Script
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    formType: 'player',
                    name: formData.name,
                    email: formData.email,
                    phone: formData.phone,
                    role: formData.role,
                    experience: formData.experience,
                    message: formData.message
                })
            });

            // Success
            alert('Thank you for your interest in joining us! We will contact you soon.');
            setShowJoinModal(false);
            setFormData({ name: '', email: '', phone: '', role: '', experience: '', message: '' });

        } catch (error) {
            console.error('Error submitting form:', error);
            alert('There was an error submitting your application. Please try again or email us directly at reginarevivers@gmail.com');
            submitButton.textContent = originalText;
            submitButton.disabled = false;
        }
    }, [formData]);

    const handleSponsorSubmit = useCallback(async (e) => {
        e.preventDefault();

        // Show loading state
        const submitButton = e.target.querySelector('button[type="submit"]');
        const originalText = submitButton.textContent;
        submitButton.textContent = 'Submitting...';
        submitButton.disabled = true;
        if (sponsorFormData.phone.length !== 10) {
            setSponsorPhoneError('Phone number must be exactly 10 digits');
            submitButton.textContent = originalText;
            submitButton.disabled = false;
            return;
        }

        try {
            
            const scriptURL = 'https://script.google.com/macros/s/AKfycby4yGDdWnnf0eLnv2wtXiMp2s1dHiBAgDzjtL-8J5QLwuXcNQ0sX8Ccra_KF3LXrCFDVA/exec';

            await fetch(scriptURL, {
                method: 'POST',
                mode: 'no-cors', 
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    formType: 'sponsor',
                    businessName: sponsorFormData.businessName,
                    email: sponsorFormData.email,
                    phone: sponsorFormData.phone,
                    tier: sponsorFormData.tier,
                    address: sponsorFormData.address,
                    comments: sponsorFormData.comments
                })
            });

            // Success
            alert('Thank you for your interest in sponsoring us! We will contact you soon.');
            setShowSponsorModal(false);
            setSponsorFormData({ businessName: '', email: '', phone: '', tier: '', address: '', comments: '' });

        } catch (error) {
            console.error('Error submitting form:', error);
            alert('There was an error submitting your inquiry. Please try again or email us directly at reginarevivers@gmail.com');
            submitButton.textContent = originalText;
            submitButton.disabled = false;
        }
    }, [sponsorFormData]);

    const NavBar = () => (
        <nav className="bg-gradient-to-r from-teal-700 to-teal-600 text-white shadow-lg sticky top-0 z-50">
            <div className="max-w-7xl mx-auto px-4">
                <div className="flex justify-between items-center py-4">
                    <div className="flex items-center space-x-4">
                        <img src="/images/logo.png" alt="Revivers Cricket Foundation" className="h-11 w-11 object-cover" />
                        <div>
                            <h1 className="text-2xl font-bold">Revivers Cricket Foundation Inc</h1>
                            <p className="text-xs text-teal-100">Est. 2025</p>
                        </div>
                    </div>

                    <div className="hidden md:flex space-x-6">
                        {['home', 'fixtures', 'team', 'gallery', 'sponsors'].map(page => (
                            <button
                                key={page}
                                onClick={() => setCurrentPage(page)}
                                className={`px-4 py-2 rounded transition ${currentPage === page ? 'bg-teal-800' : 'hover:bg-teal-700'}`}
                            >
                                {page.charAt(0).toUpperCase() + page.slice(1)}
                            </button>
                        ))}
                        <button
                            onClick={() => setShowJoinModal(true)}
                            className="bg-yellow-500 text-teal-900 px-4 py-2 rounded font-semibold hover:bg-yellow-400 transition"
                        >
                            Join Us
                        </button>
                    </div>

                    <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="md:hidden">
                        <Menu size={28} />
                    </button>
                </div>

                {mobileMenuOpen && (
                    <div className="md:hidden pb-4 space-y-2">
                        {['home', 'fixtures', 'team', 'gallery', 'sponsors'].map(page => (
                            <button
                                key={page}
                                onClick={() => { setCurrentPage(page); setMobileMenuOpen(false); }}
                                className={`block w-full text-left px-4 py-2 rounded ${currentPage === page ? 'bg-teal-800' : 'hover:bg-teal-700'}`}
                            >
                                {page.charAt(0).toUpperCase() + page.slice(1)}
                            </button>
                        ))}
                        <button
                            onClick={() => { setShowJoinModal(true); setMobileMenuOpen(false); }}
                            className="block w-full text-left bg-yellow-500 text-teal-900 px-4 py-2 rounded font-semibold"
                        >
                            Join Us
                        </button>
                    </div>
                )}
            </div>
        </nav>
    );

    const HomePage = () => (
        <div className="space-y-12">
            <div className="relative h-[520px] md:h-[560px] overflow-hidden">
                {/* Background Image */}
                <div
                    className="absolute inset-0 bg-center bg-cover"
                    style={{ backgroundImage: "url('/images/ground.jpeg')" }}
                />

                {/* Dark overlay */}
                <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/55 to-black/70" />

                {/* Green glow */}
                <div className="absolute -top-24 -left-24 w-[420px] h-[420px] bg-emerald-500/20 blur-3xl rounded-full" />
                <div className="absolute -bottom-28 -right-28 w-[520px] h-[520px] bg-emerald-400/15 blur-3xl rounded-full" />

                {/* Content */}
                <div className="relative z-10 h-full max-w-6xl mx-auto px-4 flex items-center -translate-y-10">
                    <div className="w-full text-center">
                        <p className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 border border-white/15 text-white/90 text-sm mb-6">
                            Est. 2025 • Regina, Saskatchewan
                        </p>

                        <h1 className="text-5xl md:text-6xl font-extrabold tracking-tight text-white">
                            Revivers Cricket Foundation
                        </h1>

                        <p className="text-lg md:text-xl text-white/85 mt-4">
                            Respect • Loyalty • Equality • Humanity • Transparency
                        </p>

                        <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
                            <button
                                onClick={() => setShowJoinModal(true)}
                                className="bg-yellow-500 text-teal-900 px-8 py-3 rounded-lg font-semibold text-lg hover:bg-yellow-400 transition shadow-lg"
                            >
                                Join Our Team
                            </button>

                            <button
                                onClick={() => setCurrentPage('fixtures')}
                                className="px-8 py-3 rounded-lg font-semibold text-lg bg-white/10 text-white border border-white/20 hover:bg-white/15 transition"
                            >
                                View Fixtures
                            </button>
                        </div>
                    </div>
                </div>
                {/* Hero → Content transition fade */}
                <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-[#f0fdfa] via-[#f0fdfa]/80 to-transparent z-10" />

                {/* Soft gold glow for brightness */}
                <div className="absolute bottom-[-80px] left-1/2 -translate-x-1/2 w-[600px] h-[200px] bg-yellow-400/20 blur-3xl rounded-full pointer-events-none z-0" />

            </div>


            <div className="max-w-6xl mx-auto px-4">
                {(() => {
                    if (fixtures.length === 0) return null;

                    const monthMap = {
                        January: 0, February: 1, March: 2, April: 3, May: 4, June: 5,
                        July: 6, August: 7, September: 8, October: 9, November: 10, December: 11
                    };

                    const parseDate = (dateStr) => {
                        if (!dateStr) return null;
                        const parts = dateStr.replace(',', '').split(' ');
                        if (parts.length < 3) return null;
                        return new Date(parseInt(parts[2]), monthMap[parts[0]], parseInt(parts[1]));
                    };

                    const buildCalendarUrl = (fixture) => {
                        const timeStr = fixture.time.replace(' ', '').toUpperCase();
                        const isPM = timeStr.includes('PM');
                        const [hStr, mStr] = timeStr.replace('AM', '').replace('PM', '').split(':');
                        let hour = parseInt(hStr);
                        if (isPM && hour !== 12) hour += 12;
                        if (!isPM && hour === 12) hour = 0;
                        const d = parseDate(fixture.date);
                        if (!d) return '#';
                        const pad = n => String(n).padStart(2, '0');
                        const dateStr = `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}`;
                        const startTime = `${pad(hour)}${mStr || '00'}00`;
                        const endTime = `${pad((hour + 3) % 24)}${mStr || '00'}00`;
                        const title = encodeURIComponent(`RCF vs ${fixture.opponent}`);
                        const venueNames = {
                            'Sharp': 'Sharp Park, Regina, Saskatchewan',
                            'Douglas': 'Douglas Park Cricket Ground, Regina, Saskatchewan',
                            'Grassick': 'Grassick Park, Regina, Saskatchewan',
                            'Moose Jaw': 'Moose Jaw Skate Park, Moose Jaw, Saskatchewan',
                        };
                        const venueKey = Object.keys(venueNames).find(k =>
                            fixture.venue?.trim().toLowerCase().includes(k.toLowerCase())
                        );
                        const location = encodeURIComponent(venueKey ? venueNames[venueKey] : `${fixture.venue}, Regina, Saskatchewan`);
                        const details = encodeURIComponent(`${fixture.format} | Division ${fixture.division} | ${fixture.isHomeGame ? 'Home' : 'Away'} game`);
                        return `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${title}&dates=${dateStr}T${startTime}/${dateStr}T${endTime}&details=${details}&location=${location}`;
                    };

                    const today = new Date();
                    today.setHours(0, 0, 0, 0);

                    const todayMatch = fixtures.find(f => {
                        const d = parseDate(f.date);
                        return d && d.getTime() === today.getTime();
                    });

                    const nextMatch = !todayMatch && fixtures
                        .filter(f => { const d = parseDate(f.date); return d && d > today && f.status !== 'completed'; })
                        .sort((a, b) => parseDate(a.date) - parseDate(b.date))[0];

                    const featured = todayMatch || nextMatch;
                    const isLive = !!todayMatch;

                    if (!featured) return (
                        <div>
                            <h2 className="text-3xl font-bold text-teal-800 mb-6 flex items-center"><Calendar className="mr-2" /> Fixtures</h2>
                            <div className="bg-teal-50 rounded-xl p-8 text-center text-teal-700 font-semibold">Season complete! Check back next season. 🏆</div>
                        </div>
                    );

                    return (
                        <div>
                            <h2 className="text-3xl font-bold text-teal-800 mb-6 flex items-center">
                                <Calendar className="mr-2" />
                                {isLive ? 'Match Day 🔴' : 'Next Fixture'}
                            </h2>

                            <div className={`rounded-xl shadow-lg border-2 overflow-hidden ${isLive ? 'border-red-400' : 'border-teal-200'}`}>
                                {/* Header bar */}
                                <div className={`px-6 py-3 flex items-center justify-between ${isLive ? 'bg-red-600' : 'bg-teal-700'} text-white`}>
                                    <div className="flex items-center gap-2">
                                        {isLive && <span className="relative flex h-3 w-3"><span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75"></span><span className="relative inline-flex rounded-full h-3 w-3 bg-white"></span></span>}
                                        <span className="font-semibold text-sm">{isLive ? 'LIVE TODAY' : `${featured.day}, ${featured.date}`}</span>
                                    </div>
                                    <div className="flex gap-2">
                                        <span className="text-xs font-semibold px-2 py-1 rounded-full bg-white/20">{featured.format}</span>
                                        <span className="text-xs font-semibold px-2 py-1 rounded-full bg-white/20">Div {featured.division}</span>
                                        <span className="text-xs font-semibold px-2 py-1 rounded-full bg-white/20">{featured.isHomeGame ? '🏠 Home' : '✈️ Away'}</span>
                                    </div>
                                </div>

                                {/* Match body */}
                                <div className="bg-white px-6 py-8">
                                    <div className="flex items-center justify-between">
                                        <div className="text-center flex-1">
                                            <p className={`font-extrabold text-2xl ${featured.isHomeGame ? 'text-teal-700' : 'text-gray-800'}`}>{featured.home}</p>
                                            <p className="text-xs text-gray-400 mt-1">Home</p>
                                        </div>
                                        <div className="text-center px-6">
                                            {isLive && featured.ourScore && featured.theirScore ? (
                                                <div>
                                                    <p className="text-lg font-bold text-gray-800">{featured.ourScore}</p>
                                                    <p className="text-xs text-gray-400 my-1">vs</p>
                                                    <p className="text-lg font-bold text-gray-800">{featured.theirScore}</p>
                                                </div>
                                            ) : (
                                                <div>
                                                    <p className="text-gray-300 font-bold text-lg border-2 border-gray-200 rounded-full w-12 h-12 flex items-center justify-center mx-auto">VS</p>
                                                    <p className="text-xs text-gray-400 mt-2">{featured.time}</p>
                                                </div>
                                            )}
                                        </div>
                                        <div className="text-center flex-1">
                                            <p className={`font-extrabold text-2xl ${!featured.isHomeGame ? 'text-teal-700' : 'text-gray-800'}`}>{featured.away}</p>
                                            <p className="text-xs text-gray-400 mt-1">Away</p>
                                        </div>
                                    </div>

                                    {/* Ground row */}
                                    <div className="mt-6 flex items-center justify-center gap-2 text-gray-500 text-sm">
                                        <span>📍</span>
                                        {featured.mapsLink
                                            ? <a href={featured.mapsLink} target="_blank" rel="noopener noreferrer" className="text-teal-600 hover:underline font-medium">{featured.venue}</a>
                                            : <span>{featured.venue}</span>
                                        }
                                        <span className="text-gray-300">·</span>
                                        <span>{featured.time}</span>
                                    </div>

                                    {/* Buttons */}
                                    <div className="mt-6 flex gap-3 justify-center flex-wrap">
                                        <a href={buildCalendarUrl(featured)} target="_blank" rel="noopener noreferrer"
                                            className="flex items-center gap-1.5 text-sm font-semibold px-4 py-2 rounded-lg border border-blue-200 text-blue-700 hover:bg-blue-50 transition">
                                            📅 Add to Calendar
                                        </a>
                                        {featured.mapsLink && (
                                            <a href={featured.mapsLink} target="_blank" rel="noopener noreferrer"
                                                className="flex items-center gap-1.5 text-sm font-semibold px-4 py-2 rounded-lg border border-teal-200 text-teal-700 hover:bg-teal-50 transition">
                                                📍 View Ground
                                            </a>
                                        )}
                                        <button onClick={() => setCurrentPage('fixtures')}
                                            className="flex items-center gap-1.5 text-sm font-semibold px-4 py-2 rounded-lg border border-gray-200 text-gray-600 hover:bg-gray-50 transition">
                                            View All Fixtures →
                                        </button>
                                    </div>
                                </div>
                            </div>

                            {/* Past matches link */}
                            <div className="mt-3 text-right">
                                <button onClick={() => setCurrentPage('fixtures')}
                                    className="text-sm text-teal-500 hover:text-teal-700 italic hover:underline transition">
                                    See all results & past matches →
                                </button>
                            </div>
                        </div>
                    );
                })()}
            </div>


            <p>

            </p>
            {/* Vision & Mission Section with Background Slideshow */}
            <div className="relative py-16 overflow-hidden">
                {/* Background Slideshow */}
                <div className="absolute inset-0">
                    {gallery.map((image, index) => (
                        <div
                            key={image.id}
                            className={`absolute inset-0 transition-opacity duration-1000 ${index === currentSlideIndex ? 'opacity-100' : 'opacity-0'
                                }`}
                            style={{
                                backgroundImage: `url(${image.url})`,
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                                backgroundRepeat: 'no-repeat',
                            }}
                        />
                    ))}
                    {/* Dark overlay for readability */}
                    <div className="absolute inset-0 bg-black/75" />
                </div>

                {/* Content */}
                <div className="relative z-10 max-w-6xl mx-auto px-4">

                    {/* Logo and Flag - 3x Bigger */}
                    <div className="flex flex-col sm:flex-row justify-center items-center gap-6 sm:gap-8 mb-12">
                        <img
                            src="/images/logo.png"
                            alt="Revivers Cricket Foundation Logo"
                            className="h-44 w-44 sm:h-56 sm:w-56 md:h-72 md:w-72 object-contain drop-shadow-2xl"
                        />
                    </div>

                    {/* Vision */}
                    <div className="mb-12">
                        <div className="bg-white/70 backdrop-blur-sm border-l-4 border-teal-600 p-8 rounded-lg shadow-2xl">
                            <h2 className="text-3xl font-bold text-teal-800 mb-4">Our Vision</h2>
                            <p className="text-xl text-gray-700 italic leading-relaxed">
                                "Building a championship-caliber cricket club rooted in strategy, transparency, and collective ambition.
                                Where passion meets precision, and every player owns their destiny."
                            </p>
                        </div>
                    </div>

                    {/* Mission */}
                    <div>
                        <div className="bg-white/70 backdrop-blur-sm border-l-4 border-teal-600 p-8 rounded-lg shadow-2xl">
                            <h2 className="text-3xl font-bold text-teal-800 mb-4">Our Mission</h2>
                            <p className="text-xl text-gray-700 italic mb-6 leading-relaxed">
                                "To build a high-performance cricket culture where every player grows with purpose,
                                progress is celebrated loudly, and trust is earned through transparency."
                            </p>
                            <div className="grid md:grid-cols-3 gap-6">
                                <div className="bg-teal-50/60 p-6 rounded-lg">
                                    <h3 className="text-lg font-bold text-teal-900 mb-3">
                                        Player-Centric Development
                                    </h3>
                                    <p className="text-gray-700 leading-relaxed">
                                        We don't just pick a XI, we invest in every individual, tailoring coaching and opportunities
                                        to elevate each player's unique strengths.
                                    </p>
                                </div>
                                <div className="bg-teal-50/60 p-6 rounded-lg">
                                    <h3 className="text-lg font-bold text-teal-900 mb-3">
                                        The "Dugout" Culture
                                    </h3>
                                    <p className="text-gray-700 leading-relaxed">
                                        We cheer for the little wins, tighter lines, smarter shot selection, better intent
                                        with the same energy as big centuries and match-winning spells.
                                    </p>
                                </div>
                                <div className="bg-teal-50/60 p-6 rounded-lg">
                                    <h3 className="text-lg font-bold text-teal-900 mb-3">
                                        Radical Transparency
                                    </h3>
                                    <p className="text-gray-700 leading-relaxed">
                                        Clear selection criteria. Clear roles. Clear finances. We keep everything open and honest,
                                        so every player understands the "why" behind decisions.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



            <div className="max-w-6xl mx-auto px-4">
                <h2 className="text-3xl font-bold text-teal-800 mb-6 flex items-center">
                    <Users className="mr-2" /> Meet The Revivers
                </h2>
                <div className="relative rounded-2xl p-8 overflow-hidden bg-gradient-to-r from-emerald-950 via-teal-950 to-zinc-950 border border-emerald-800/40 shadow-2xl">
                    <div className="absolute inset-0 flex justify-center items-center pointer-events-none">
                        <div className="w-[420px] h-[260px] bg-emerald-500/20 blur-3xl rounded-full" />
                    </div>
                    <div className="flex justify-center items-center space-x-8">
                        {[currentPlayerIndex, (currentPlayerIndex + 1) % players.length, (currentPlayerIndex + 2) % players.length].map((idx, i) => (
                            <div key={idx} className={`transform transition-all duration-500 ${i === 1 ? 'scale-110 z-10' : 'scale-90 opacity-70'}`}>
                                <div className="bg-white rounded-lg overflow-hidden shadow-2xl w-64">
                                    <img
                                        src={players[idx].imagebig}
                                        alt={players[idx].name}
                                        className="w-full h-80 object-cover object-top"
                                    />
                                    <div className="p-4 bg-teal-800 text-white">
                                        <div className="flex justify-between items-start mb-2">
                                            <div>
                                                <p className="text-2xl font-bold">{players[idx].number}</p>
                                                <h3 className="text-xl font-bold">{players[idx].name}</h3>
                                            </div>
                                        </div>
                                        <p className="text-sm text-emerald-200">{players[idx].role}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <div className="max-w-6xl mx-auto px-4">
                <h2 className="text-3xl font-bold text-teal-800 mb-6 flex items-center">
                    <Award className="mr-2" /> Our Sponsors
                </h2>

                <div className="bg-gradient-to-br from-white via-emerald-50 to-yellow-50 rounded-xl shadow-lg p-6">
                    {sponsors.map((sponsor, idx) => (
                        <div key={`${sponsor.name}-${idx}`} className={idx !== 0 ? "mt-10" : ""}>
                            <h3 className="text-2xl font-bold text-teal-700 mb-4">
                                {sponsor.tier} Sponsor
                            </h3>

                            <div className="border-l-4 border-teal-600 pl-6">
                                <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-6">
                                    {/* LEFT: Text */}
                                    <div className="flex-1">
                                        <h4 className="text-xl font-bold mb-2">{sponsor.name}</h4>
                                        <p className="text-gray-600 mb-2">{sponsor.description}</p>
                                        <p className="text-gray-700 mb-3">{sponsor.details}</p>

                                        <div className="flex flex-wrap gap-4">
                                            {sponsor.website && (
                                                <a
                                                    href={sponsor.website}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="text-teal-600 hover:text-teal-700 font-semibold"
                                                >
                                                    Visit Website →
                                                </a>
                                            )}

                                            {sponsor.map && (
                                                <a
                                                    href={sponsor.map}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="text-teal-600 hover:text-teal-700 font-semibold"
                                                >
                                                    Visit Store →
                                                </a>
                                            )}
                                        </div>
                                    </div>

                                    {/* RIGHT: Image (only if logo exists) */}
                                    {sponsor.logo && (
                                        <div className="md:w-[340px] w-full flex md:justify-end">
                                            <div className="bg-white rounded-xl shadow-md p-3 border border-gray-100">
                                                <img
                                                    src={sponsor.logo}
                                                    alt={sponsor.name}
                                                    className="w-full md:w-[320px] h-[220px] object-cover rounded-lg"
                                                    loading="lazy"
                                                />
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Divider between sponsors */}
                            {idx !== sponsors.length - 1 && (
                                <div className="mt-10 border-t border-teal-100" />
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );

    const FixturesPage = () => {
        const odp = fixtures.filter(f => f.format?.toUpperCase().includes('ODP'));
        const t20 = fixtures.filter(f => f.format?.toUpperCase().includes('T20'));
        const displayed = fixtureTab === 'T20' ? t20 : odp;

        const monthMap = {
            January: 0, February: 1, March: 2, April: 3, May: 4, June: 5,
            July: 6, August: 7, September: 8, October: 9, November: 10, December: 11
        };

        const parseDate = (dateStr) => {
            if (!dateStr) return null;
            const parts = dateStr.replace(',', '').split(' ');
            if (parts.length < 3) return null;
            return new Date(parseInt(parts[2]), monthMap[parts[0]], parseInt(parts[1]));
        };

        const buildCalendarUrl = (fixture) => {
            const timeStr = fixture.time.replace(' ', '').toUpperCase();
            const isPM = timeStr.includes('PM');
            const [hStr, mStr] = timeStr.replace('AM', '').replace('PM', '').split(':');
            let hour = parseInt(hStr);
            if (isPM && hour !== 12) hour += 12;
            if (!isPM && hour === 12) hour = 0;
            const d = parseDate(fixture.date);
            if (!d) return '#';
            const pad = n => String(n).padStart(2, '0');
            const dateStr = `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}`;
            const startTime = `${pad(hour)}${mStr || '00'}00`;
            const endTime = `${pad((hour + 3) % 24)}${mStr || '00'}00`;
            const title = encodeURIComponent(`RCF vs ${fixture.opponent}`);
            const venueNames = {
                'Sharp': 'Sharp Park, Regina, Saskatchewan',
                'Douglas': 'Douglas Park Cricket Ground, Regina, Saskatchewan',
                'Grassick': 'Grassick Park, Regina, Saskatchewan',
                'Moose Jaw': 'Moose Jaw Skate Park, Moose Jaw, Saskatchewan',
            };
            const venueKey = Object.keys(venueNames).find(k =>
                fixture.venue?.trim().toLowerCase().includes(k.toLowerCase())
            );
            const location = encodeURIComponent(venueKey ? venueNames[venueKey] : `${fixture.venue}, Regina, Saskatchewan`);
            const details = encodeURIComponent(`${fixture.format} | Division ${fixture.division} | ${fixture.isHomeGame ? 'Home' : 'Away'} game`);
            return `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${title}&dates=${dateStr}T${startTime}/${dateStr}T${endTime}&details=${details}&location=${location}`;
        };

        const isCompleted = f => f.status?.toLowerCase() === 'completed';

        const FixtureCard = ({ fixture }) => (
            <div className={`bg-white rounded-xl shadow-md border-2 p-5 hover:shadow-lg transition ${isCompleted(fixture) ? 'border-gray-200' : 'border-gray-100'}`}>
                <div className="flex justify-between items-start mb-3">
                    <div className="flex gap-2 flex-wrap">
                        <span className={`text-xs font-semibold px-2 py-1 rounded-full ${fixture.format?.toUpperCase().includes('T20') ? 'bg-yellow-100 text-yellow-800' : 'bg-blue-100 text-blue-800'}`}>
                            {fixture.format}
                        </span>
                        <span className={`text-xs font-semibold px-2 py-1 rounded-full ${fixture.division === 'D' ? 'bg-yellow-600 text-white' : 'bg-blue-700 text-white'}`}>
                            Division {fixture.division}
                        </span>
                        <span className={`text-xs font-semibold px-2 py-1 rounded-full ${fixture.isHomeGame ? 'bg-teal-100 text-teal-700' : 'bg-gray-100 text-gray-600'}`}>
                            {fixture.isHomeGame ? '🏠 Home' : '✈️ Away'}
                        </span>
                        {isCompleted(fixture) && (
                            <span className="text-xs font-semibold px-2 py-1 rounded-full bg-gray-100 text-gray-500">Full Time</span>
                        )}
                    </div>
                    <span className="text-xs text-gray-400 whitespace-nowrap ml-2">{fixture.day}</span>
                </div>

                {/* Teams */}
                <div className="flex items-center justify-between my-4">
                    <div className="text-center flex-1">
                        <p className={`font-bold text-base leading-snug ${fixture.isHomeGame ? 'text-teal-700' : 'text-gray-700'}`}>{fixture.home}</p>
                        {isCompleted(fixture) && fixture.ourScore && (
                            <>
                                <p className="text-lg font-extrabold text-gray-800 mt-1">{fixture.isHomeGame ? fixture.ourScore : fixture.theirScore}</p>
                                <p className="text-xs text-black-400">{fixture.isHomeGame ? fixture.ourOvers : fixture.theirOvers} ov</p>
                            </>
                        )}
                        <p className="text-xs text-gray-400 mt-1">Home</p>
                    </div>
                    <div className="text-center px-3">
                        <span className="text-gray-300 font-bold text-sm border border-gray-200 rounded-full px-2 py-1">VS</span>
                    </div>
                    <div className="text-center flex-1">
                        <p className={`font-bold text-base leading-snug ${!fixture.isHomeGame ? 'text-teal-700' : 'text-gray-700'}`}>{fixture.away}</p>
                        {isCompleted(fixture) && fixture.theirScore && (
                            <>
                                <p className="text-lg font-extrabold text-gray-800 mt-1">{fixture.isHomeGame ? fixture.theirScore : fixture.ourScore}</p>
                                <p className="text-xs text-black-400">{fixture.isHomeGame ? fixture.theirOvers : fixture.ourOvers} ov</p>
                            </>
                        )}
                        <p className="text-xs text-gray-400 mt-1">Away</p>
                    </div>
                </div>

                {/* Result banner */}
                {isCompleted(fixture) && fixture.result && (
                    <div className={`text-center text-sm font-bold py-1.5 px-3 rounded-lg mb-3 ${fixture.result.toLowerCase().includes('won') ? 'bg-emerald-50 text-emerald-700' : fixture.result.toLowerCase().includes('lost') ? 'bg-red-50 text-red-600' : 'bg-gray-50 text-gray-600'}`}>
                        {fixture.result}
                    </div>
                )}

                {/* Match Details */}
                <div className="border-t border-gray-100 pt-3 grid grid-cols-3 gap-2 text-center mb-4">
                    <div>
                        <p className="text-xs text-gray-400">Date</p>
                        <p className="font-medium text-xs mt-0.5">{fixture.date}</p>
                    </div>
                    <div>
                        <p className="text-xs text-gray-400">Game Time</p>
                        <p className="font-medium text-xs mt-0.5">{fixture.time}</p>
                    </div>
                    <div>
                        <p className="text-xs text-gray-400">Ground</p>
                        <p className="font-medium text-xs mt-0.5">{fixture.venue}</p>
                    </div>
                </div>

                {/* Action Buttons — upcoming only */}
                {!isCompleted(fixture) && (
                    <div className="flex gap-2 pt-1">
                        {fixture.mapsLink && (
                            <a href={fixture.mapsLink} target="_blank" rel="noopener noreferrer"
                                className="flex-1 flex items-center justify-center gap-1.5 text-xs font-semibold px-3 py-2 rounded-lg border border-teal-200 text-teal-700 hover:bg-teal-50 transition">
                                📍 View Ground
                            </a>
                        )}
                        <a href={buildCalendarUrl(fixture)} target="_blank" rel="noopener noreferrer"
                            className="flex-1 flex items-center justify-center gap-1.5 text-xs font-semibold px-3 py-2 rounded-lg border border-blue-200 text-blue-700 hover:bg-blue-50 transition">
                            📅 Add to Calendar
                        </a>
                    </div>
                )}
            </div>
        );

        return (
            <div className="max-w-6xl mx-auto px-4 py-8">
                <h1 className="text-4xl font-bold text-teal-800 mb-2">Fixtures & Results</h1>
                <p className="text-gray-500 mb-8">Revivers Cricket Foundation — 2026 Season</p>

                {/* Tabs */}
                <div className="flex gap-3 mb-8">
                    {['T20', 'ODP'].map(tab => (
                        <button
                            key={tab}
                            onClick={() => setFixtureTab(tab)}
                            className={`px-6 py-2 rounded-full font-semibold transition text-sm ${fixtureTab === tab
                                ? 'bg-teal-700 text-white shadow'
                                : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                                }`}
                        >
                            {tab === 'T20' ? '🏏 T20 Fixtures' : '🏟️ ODP 35 Fixtures'}
                        </button>
                    ))}
                </div>

                {fixtures.length > 0 && (
                    <p className="text-sm text-gray-400 mb-4">{displayed.length} match{displayed.length !== 1 ? 'es' : ''} scheduled</p>
                )}

                {fixtures.length === 0 ? (
                    <div className="text-center py-20 text-gray-400">
                        <div className="animate-pulse text-4xl mb-4">🏏</div>
                        <p>Loading fixtures...</p>
                    </div>
                ) : displayed.length === 0 ? (
                    <div className="text-center py-20 text-gray-400">No {fixtureTab} fixtures found.</div>
                ) : (
                    <div className="grid gap-4 md:grid-cols-2">
                        {displayed.map(f => <FixtureCard key={f.id} fixture={f} />)}
                    </div>
                )}
            </div>
        );
    };


    const TeamPage = () => (
        <div className="max-w-6xl mx-auto px-4 py-8">
            <h1 className="text-4xl font-bold text-teal-800 mb-8">Our Squad</h1>
            <div className="grid md:grid-cols-3 gap-6">
                {players.map((player, idx) => (
                    <div key={idx} className="rounded-xl shadow-xl overflow-hidden transform hover:scale-105 transition bg-gray-900 text-white">
                        {/* Header banner with player image */}
                        <div className="relative bg-gradient-to-br from-teal-900 via-gray-800 to-gray-900 p-4 flex items-end gap-4 min-h-36">
                            <img
                                src={player.imagebig}
                                alt={player.name}
                                className="w-28 h-36 object-cover object-top rounded-lg shadow-lg flex-shrink-0"
                            />
                            <div className="pb-1">
                                <h3 className="text-2xl font-bold leading-tight">{player.name}</h3>
                                <p className="text-teal-300 text-sm mt-0.5">RCF</p>
                                <p className="text-gray-400 text-xs mt-1 uppercase tracking-wide">{player.role}</p>
                            </div>
                            <div className="absolute top-3 right-4 text-5xl font-extrabold text-white/10 select-none leading-none">
                                #{player.number}
                            </div>
                        </div>

                        {/* Details section */}
                        <div className="bg-gray-850 divide-y divide-gray-700" style={{ backgroundColor: '#1a1f2e' }}>
                            <div className="grid grid-cols-2 divide-x divide-gray-700">
                                <div className="px-4 py-3">
                                    <p className="text-gray-400 text-xs uppercase tracking-wider mb-1">Jersey No.</p>
                                    <p className="text-white font-bold text-lg">#{player.number}</p>
                                </div>
                                <div className="px-4 py-3">
                                    <p className="text-gray-400 text-xs uppercase tracking-wider mb-1">Player Role</p>
                                    <p className="text-white font-semibold text-sm leading-snug">{player.role}</p>
                                </div>
                            </div>

                            <div className="grid grid-cols-2 divide-x divide-gray-700">
                                <div className="px-4 py-3">
                                    <p className="text-gray-400 text-xs uppercase tracking-wider mb-1">Batting Style</p>
                                    <p className="text-white font-semibold text-sm leading-snug">{player.battingStyle || '—'}</p>
                                </div>
                                <div className="px-4 py-3">
                                    <p className="text-gray-400 text-xs uppercase tracking-wider mb-1">Bowling Style</p>
                                    <p className="text-white font-semibold text-sm leading-snug">{player.bowlingStyle || '—'}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );

    const GalleryPage = () => (
        <div className="max-w-6xl mx-auto px-4 py-8">
            <h1 className="text-4xl font-bold text-teal-800 mb-8 flex items-center">
                <Award className="mr-2" /> Gallery
            </h1>
            <div className="grid md:grid-cols-2 gap-6">
                {gallery.map(item => (
                    <div key={item.id} className="bg-white rounded-lg shadow-lg overflow-hidden">
                        <img src={item.url} alt={item.caption} className="w-full h-80 object-cover" />
                        <div className="p-4 bg-teal-50">
                            <p className="text-gray-700">{item.caption}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );

    const SponsorsPage = () => (
        <div className="max-w-6xl mx-auto px-4 py-8">
            <h1 className="text-4xl font-bold text-teal-800 mb-4">Sponsorship Opportunities</h1>
            <p className="text-lg text-gray-700 mb-8">Join us in building a championship-caliber cricket club. Your support helps us achieve excellence on and off the field.</p>

            <div className="grid md:grid-cols-2 gap-6 mb-12">
                <div className="bg-gradient-to-br from-yellow-400 to-yellow-500 rounded-lg p-6 text-gray-900 shadow-xl">
                    <h3 className="text-2xl font-bold mb-3">Maximum Partners (6s) - $600</h3>
                    <ul className="space-y-2 mb-4">
                        <li>✓ Logo on jersey front (prime placement)</li>
                        <li>✓ Social media mentions</li>
                        <li>✓ Recognized as Gold Medal Sponsor</li>
                        <li>✓ Complimentary club jersey</li>
                        <li>✓ Honored as Chief Guest at annual award night</li>
                    </ul>
                    <p className="italic">Sixes are game-changers — maximum impact, legacy recognition</p>
                </div>

                <div className="bg-gradient-to-br from-gray-300 to-gray-400 rounded-lg p-6 text-gray-900 shadow-xl">
                    <h3 className="text-2xl font-bold mb-3">Boundary Boosters (4s) - $400</h3>
                    <ul className="space-y-2 mb-4">
                        <li>✓ Logo on jersey back</li>
                        <li>✓ Social media mentions</li>
                        <li>✓ Recognized as Silver Medal Sponsor</li>
                        <li>✓ Complimentary club jersey</li>
                    </ul>
                    <p className="italic">Boundaries bring cheers and visibility — your brand hits the ropes with us</p>
                </div>

                <div className="bg-gradient-to-br from-orange-400 to-orange-500 rounded-lg p-6 text-gray-900 shadow-xl">
                    <h3 className="text-2xl font-bold mb-3">Quick Double (2s) - $200</h3>
                    <ul className="space-y-2 mb-4">
                        <li>✓ Logo on jersey sleeves</li>
                        <li>✓ Social media mentions</li>
                        <li>✓ Recognized as Bronze Medal Sponsor</li>
                    </ul>
                    <p className="italic">Hustle and teamwork — your support builds partnerships</p>
                </div>

                <div className="bg-gradient-to-br from-teal-400 to-teal-500 rounded-lg p-6 text-white shadow-xl">
                    <h3 className="text-2xl font-bold mb-3">Steady Singles (1s) - $100</h3>
                    <ul className="space-y-2 mb-4">
                        <li>✓ Social media mentions (Instagram & WhatsApp)</li>
                    </ul>
                    <p className="italic">Every single keeps the scoreboard ticking — grassroots support that builds momentum</p>
                </div>
            </div>

            <div>
                <h2 className="text-3xl font-bold text-teal-800 mb-6">Our Valued Sponsors</h2>
                <div className="space-y-6">
                    {sponsors.map((sponsor, idx) => (
                        <div key={idx} className="bg-white rounded-lg shadow-lg p-6 border-l-4 border-teal-600">
                            <div className="flex flex-col md:flex-row md:items-start md:justify-between">
                                <div className="flex-1">
                                    <div className="flex items-center mb-3">
                                        <img src={sponsor.logo} alt={sponsor.name} className="h-16 mr-4" />
                                        <div>
                                            <h3 className="text-xl font-bold text-teal-800">{sponsor.name}</h3>
                                            <span className="inline-block bg-teal-100 text-teal-800 px-3 py-1 rounded text-sm font-semibold">{sponsor.tier}</span>
                                        </div>
                                    </div>
                                    <p className="text-gray-600 font-semibold mb-2">{sponsor.description}</p>
                                    <p className="text-gray-700 mb-3">{sponsor.details}</p>
                                    {sponsor.website && (
                                        <a href={sponsor.website} target="_blank" rel="noopener noreferrer" className="text-teal-600 hover:text-teal-700 font-semibold">
                                            Visit Website →
                                        </a>
                                    )}
                                    <p>
                                    </p>
                                    {sponsor.map && (
                                        <a href={sponsor.map} target="_blank" rel="noopener noreferrer" className="text-teal-600 hover:text-teal-700 font-semibold">
                                            Visit Store →
                                        </a>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div className="mt-12 bg-gradient-to-r from-teal-700 to-teal-600 rounded-lg p-8 text-white text-center">
                <h2 className="text-3xl font-bold mb-4">Become a Sponsor</h2>
                <p className="text-lg mb-6">Partner with Revivers Cricket Foundation and be part of our journey to championship success</p>
                <button
                    onClick={() => setShowSponsorModal(true)}
                    className="bg-yellow-500 text-teal-900 px-8 py-3 rounded-lg font-semibold text-lg hover:bg-yellow-400 transition"
                >
                    Get in Touch
                </button>
            </div>
        </div>
    );

    return (
        <div className="min-h-screen" style={{ background: 'linear-gradient(to bottom, #f0fdfa 0%, #e0f2f1 100%)' }}>
            <div>
                <NavBar />

                <main className="pb-12">
                    {currentPage === 'home' && <HomePage />}
                    {currentPage === 'fixtures' && <FixturesPage />}
                    {currentPage === 'team' && <TeamPage />}
                    {currentPage === 'gallery' && <GalleryPage />}
                    {currentPage === 'sponsors' && <SponsorsPage />}
                </main>

                {showJoinModal && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                        <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
                            <div className="sticky top-0 bg-teal-700 text-white p-6 flex justify-between items-center">
                                <h2 className="text-2xl font-bold">Join Revivers Cricket Foundation</h2>
                                <button onClick={() => setShowJoinModal(false)} className="hover:bg-teal-800 p-2 rounded">
                                    <X size={24} />
                                </button>
                            </div>

                            <form onSubmit={handleSubmit} className="p-6 space-y-4">
                                <div>
                                    <label className="block text-gray-700 font-semibold mb-2">Full Name *</label>
                                    <input
                                        type="text"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleInputChange}
                                        required
                                        className="w-full px-4 py-2 border border-gray-300 rounded focus:outline-none focus:border-teal-600"
                                        placeholder="Enter your full name"
                                    />
                                </div>

                                <div>
                                    <label className="block text-gray-700 font-semibold mb-2">Email Address *</label>
                                    <input
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleInputChange}
                                        required
                                        className="w-full px-4 py-2 border border-gray-300 rounded focus:outline-none focus:border-teal-600"
                                        placeholder="your.email@example.com"
                                    />
                                </div>

                                <div>
                                    <label className="block text-gray-700 font-semibold mb-2">Phone Number *</label>
                                    <input
                                        type="tel"
                                        name="phone"
                                        value={formData.phone}
                                        onChange={handleInputChange}
                                        required
                                        maxLength={10}
                                        placeholder="10-digit number"
                                        className={`w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-teal-500 ${joinPhoneError ? 'border-red-400' : 'border-gray-300'}`}
                                    />
                                    {joinPhoneError && <p className="text-red-500 text-sm mt-1">{joinPhoneError}</p>}
                                </div>

                                <div>
                                    <label className="block text-gray-700 font-semibold mb-2">Preferred Role *</label>
                                    <select
                                        name="role"
                                        value={formData.role}
                                        onChange={handleInputChange}
                                        required
                                        className="w-full px-4 py-2 border border-gray-300 rounded focus:outline-none focus:border-teal-600"
                                    >
                                        <option value="">Select your role</option>
                                        <option value="Batter">Batter</option>
                                        <option value="Bowler-Fast">Bowler - Fast</option>
                                        <option value="Bowler-Spin">Bowler - Spin</option>
                                        <option value="All-Rounder">All Rounder</option>
                                        <option value="Wicketkeeper">Wicketkeeper Batter</option>
                                    </select>
                                </div>

                                <div>
                                    <label className="block text-gray-700 font-semibold mb-2">Cricket Experience *</label>
                                    <select
                                        name="experience"
                                        value={formData.experience}
                                        onChange={handleInputChange}
                                        required
                                        className="w-full px-4 py-2 border border-gray-300 rounded focus:outline-none focus:border-teal-600"
                                    >
                                        <option value="">Select experience level</option>
                                        <option value="Beginner">Beginner (0-2 years)</option>
                                        <option value="Intermediate">Intermediate (3-5 years)</option>
                                        <option value="Advanced">Advanced (6+ years)</option>
                                        <option value="Professional">Professional/Semi-Professional</option>
                                    </select>
                                </div>

                                <div>
                                    <label className="block text-gray-700 font-semibold mb-2">Additional Information</label>
                                    <textarea
                                        name="message"
                                        value={formData.message}
                                        onChange={handleInputChange}
                                        rows="4"
                                        className="w-full px-4 py-2 border border-gray-300 rounded focus:outline-none focus:border-teal-600"
                                        placeholder="Tell us about yourself, your cricket background..."
                                    ></textarea>
                                </div>

                                <div className="flex gap-4 pt-4">
                                    <button
                                        type="submit"
                                        className="flex-1 bg-teal-700 text-white px-6 py-3 rounded-lg font-semibold hover:bg-teal-800 transition"
                                    >
                                        Submit Application
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => setShowJoinModal(false)}
                                        className="px-6 py-3 border border-gray-300 rounded-lg font-semibold hover:bg-gray-100 transition"
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                )}

                {showSponsorModal && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                        <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
                            <div className="sticky top-0 bg-teal-700 text-white p-6 flex justify-between items-center">
                                <h2 className="text-2xl font-bold">Become a Sponsor</h2>
                                <button onClick={() => setShowSponsorModal(false)} className="hover:bg-teal-800 p-2 rounded">
                                    <X size={24} />
                                </button>
                            </div>

                            <form onSubmit={handleSponsorSubmit} className="p-6 space-y-4">
                                <div>
                                    <label className="block text-gray-700 font-semibold mb-2">Full Name / Name of the Business *</label>
                                    <input
                                        type="text"
                                        name="businessName"
                                        value={sponsorFormData.businessName}
                                        onChange={handleSponsorInputChange}
                                        required
                                        className="w-full px-4 py-2 border border-gray-300 rounded focus:outline-none focus:border-teal-600"
                                        placeholder="Enter your name or business name"
                                    />
                                </div>

                                <div>
                                    <label className="block text-gray-700 font-semibold mb-2">Email Address *</label>
                                    <input
                                        type="email"
                                        name="email"
                                        value={sponsorFormData.email}
                                        onChange={handleSponsorInputChange}
                                        required
                                        className="w-full px-4 py-2 border border-gray-300 rounded focus:outline-none focus:border-teal-600"
                                        placeholder="your.email@example.com"
                                    />
                                </div>

                                <div>
                                    <label className="block text-gray-700 font-semibold mb-2">Phone Number *</label>
                                    <input
                                        type="tel"
                                        name="phone"
                                        value={sponsorFormData.phone}
                                        onChange={handleSponsorInputChange}
                                        required
                                        maxLength={10}
                                        placeholder="10-digit number"
                                        className={`w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-teal-500 ${sponsorPhoneError ? 'border-red-400' : 'border-gray-300'}`}
                                    />
                                    {sponsorPhoneError && <p className="text-red-500 text-sm mt-1">{sponsorPhoneError}</p>}
                                </div>

                                <div>
                                    <label className="block text-gray-700 font-semibold mb-2">Sponsorship Tier *</label>
                                    <select
                                        name="tier"
                                        value={sponsorFormData.tier}
                                        onChange={handleSponsorInputChange}
                                        required
                                        className="w-full px-4 py-2 border border-gray-300 rounded focus:outline-none focus:border-teal-600"
                                    >
                                        <option value="">Select sponsorship tier</option>
                                        <option value="maximum-partners">Maximum Partners (6s) - $600</option>
                                        <option value="boundary-boosters">Boundary Boosters (4s) - $400</option>
                                        <option value="quick-double">Quick Double (2s) - $200</option>
                                        <option value="steady-singles">Steady Singles (1s) - $100</option>
                                    </select>
                                </div>

                                <div>
                                    <label className="block text-gray-700 font-semibold mb-2">Address</label>
                                    <input
                                        type="text"
                                        name="address"
                                        value={sponsorFormData.address}
                                        onChange={handleSponsorInputChange}
                                        className="w-full px-4 py-2 border border-gray-300 rounded focus:outline-none focus:border-teal-600"
                                        placeholder="Your address"
                                    />
                                </div>

                                <div>
                                    <label className="block text-gray-700 font-semibold mb-2">Comments</label>
                                    <textarea
                                        name="comments"
                                        value={sponsorFormData.comments}
                                        onChange={handleSponsorInputChange}
                                        rows="4"
                                        className="w-full px-4 py-2 border border-gray-300 rounded focus:outline-none focus:border-teal-600"
                                        placeholder="Any additional information or questions..."
                                    ></textarea>
                                </div>

                                <div className="flex gap-4 pt-4">
                                    <button
                                        type="submit"
                                        className="flex-1 bg-teal-700 text-white px-6 py-3 rounded-lg font-semibold hover:bg-teal-800 transition"
                                    >
                                        Submit Sponsorship Inquiry
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => setShowSponsorModal(false)}
                                        className="px-6 py-3 border border-gray-300 rounded-lg font-semibold hover:bg-gray-100 transition"
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                )}

                <footer className="bg-teal-900 text-white py-8">
                    <div className="max-w-6xl mx-auto px-4">
                        <div className="grid md:grid-cols-3 gap-8">
                            <div>
                                <h3 className="text-xl font-bold mb-3">Revivers Cricket Foundation</h3>
                                <p className="text-teal-200 ">Revivers Cricket Foundation isn't just a cricket club, it's a movement toward professional standards, transparent operations, and collective glory.</p>
                            </div>
                            <div>
                                <h3 className="text-xl font-bold mb-3">Quick Links</h3>
                                <div className="space-y-2">
                                    <button onClick={() => setCurrentPage('home')} className="block text-teal-200 hover:text-white">Home</button>
                                    <button onClick={() => setCurrentPage('fixtures')} className="block text-teal-200 hover:text-white">Fixtures</button>
                                    <button onClick={() => setCurrentPage('team')} className="block text-teal-200 hover:text-white">Team</button>
                                </div>
                            </div>
                            <div>
                                <h3 className="text-xl font-bold mb-3">Contact Us</h3>

                                <p className="text-teal-200">Regina, Saskatchewan, Canada</p>

                                {/* Email */}
                                <div className="mt-2 flex items-center gap-2 text-teal-200">
                                    <Mail size={18} className="text-teal-100" />
                                    <a
                                        href="mailto:reginarevivers@gmail.com"
                                        className="text-white hover:text-teal-100 underline underline-offset-4"
                                    >
                                        reginarevivers@gmail.com
                                    </a>
                                </div>

                                {/* Socials */}
                                <div className="mt-4 space-y-2">
                                    {/* Label on its own line */}
                                    <p className="text-teal-200">Follow us on</p>

                                    {/* Instagram row */}
                                    <a
                                        href="https://www.instagram.com/revivers_cricket_foundation?igsh=enpoNjkxNHh4am93"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="flex items-center gap-2 text-white hover:text-teal-100 underline underline-offset-4 w-fit"
                                    >
                                        <Instagram size={18} className="text-teal-100" />
                                        Instagram
                                    </a>

                                    {/* Facebook row */}
                                    <a
                                        href="https://www.facebook.com/share/1HAX3d6AHM/?mibextid=wwXIfr"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="flex items-center gap-2 text-white hover:text-teal-100 underline underline-offset-4 w-fit"
                                    >
                                        <Facebook size={18} className="text-teal-100" />
                                        Facebook
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="border-t border-teal-800 mt-8 pt-6 text-center text-teal-300">
                            <p>&copy; 2025 Revivers Cricket Foundation Inc. All rights reserved.</p>
                        </div>
                    </div>
                </footer>
            </div>
        </div>
    );
};

export default ReginaReviversWebsite;